import React from 'react';
import { RouteComponentProps, useHistory, withRouter, useLocation } from 'react-router-dom';
import SiteSettings from 'src/siteSetting';
import { compose } from 'recompose';

// Mui
import { useTheme, useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import { rememberMeRedirect } from './loginAccounts';
import { getQueryParam } from 'src/utilities/queryParams';

// helpers
import { isNotEmpty } from 'src/utilities/hasValue';
import CookieLocalStorage from 'src/features/Auth/Login/CookieLocalStorage';

// components
import AuthRootLayout from 'src/components/Layouts/AuthRootLayout';
import LoginContainer from '../SignUp/LoginContainer';
import CookieConsent from 'src/bootstrap/CookieConsent';

type CombinedProps = RouteComponentProps<{}>;

const Login: React.FC<CombinedProps> = (props, State) => {

  const { breakpoints } = useTheme();
  const matchesLg = useMediaQuery(breakpoints.down('lg'));
  const history = useHistory();
  const location = useLocation();



  const redirectMeta = getQueryParam(location.search, 'returnTo');

  const returnTo = isNotEmpty(redirectMeta) ? String(window.atob(redirectMeta)) : '';

  // Checks is User has enabled Remember me on browser session
  if (CookieLocalStorage.isUserRemembered()) {
    rememberMeRedirect(
      CookieLocalStorage.getUser(),
      returnTo,
      history
    );
  }


  return (
    <AuthRootLayout showHeader={true}>
      {() =>
        <>
          <Box
            display='flex'
            justifyContent='center'
            alignItems={matchesLg ? 'flex-start' : 'center'}
            height='calc(100vh - 135px)'
            padding='20px 0'
            overflow='scroll'
            className='auth-content-wrap'
          >
            <LoginContainer isMagicLinkEnabled={SiteSettings.isMagicLinkEnabled()} />
          </Box>
          {SiteSettings.generalCookiePolicyConsent() && <CookieConsent />}
        </>
      }
    </AuthRootLayout>
  );
};

export default compose(withRouter)(Login);
